// extracted by mini-css-extract-plugin
export default {"container":"styles_container__ExtdW","item":"styles_item__IG+QC","label":"styles_label__VaCSJ"};